module.exports = __webpack_public_path__ + "static/media/logo-white.af8db45b.png";